export default "__VITE_ASSET__CtMhN$9z__"